var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-card"},[_c('div',{staticClass:"div-card-content"},[_c('p',{staticClass:"number mb-0 mt-12"},[_vm._v(_vm._s(_vm.openComplaints))]),_c('p',{staticClass:"label"},[_vm._v("pending complaints")])])])}
var staticRenderFns = []

export { render, staticRenderFns }